module.exports = __webpack_public_path__ + "static/media/2010_maleRate_femaleRate.b1cf86d1.png";